import { inject, Injectable } from '@angular/core';
import type { NotificationMessage } from '@/core/notification/notification-message.model';
import { CURVE_RETRIEVED } from '@/core/notification/notification-message.model';
import { RealtimeNotificationStore } from '@/features/realtime-notification-store.service';

@Injectable({ providedIn: 'root' })
export class PushNotificationDispatcher {
  private readonly realtimeNotificationStore = inject(RealtimeNotificationStore);

  dispatch(raw: unknown): void {
    try {
      const message = parseNotificationMessage(raw);
      this.realtimeNotificationStore.handleCurveRetrieved(message.opportunityId);
    } catch (e) {
      console.error('Failed to parse notification message', e);
    }
  }
}

const parseNotificationMessage = (raw: unknown): NotificationMessage => {
  if (typeof raw === 'string') {
    const payload = JSON.parse(raw) as Partial<NotificationMessage>;
    if (payload.type === CURVE_RETRIEVED && typeof payload.opportunityId === 'string') {
      return { type: CURVE_RETRIEVED, opportunityId: payload.opportunityId };
    }
  }
  throw new Error('Invalid notification message');
};
